import React from 'react';

import { observable } from 'mobx';
import { observer } from 'mobx-react';

import createContext from 'bz-utilities/hooks/context-v2';

export interface IThemeValues {
  accent: string;
  primary: string;
  secondary: string;
}
export interface ITheme extends IThemeValues {
  accent: string;
  id: number;
  name: string;
  primary: string;
  secondary: string;
}

export const defaultTheme: ITheme = {
  accent: 'gray',
  id: 1,
  name: 'default',
  primary: 'blue',
  secondary: 'sky'
};

export const [BzThemeStoreContext, useBzThemeStore] = createContext<BzThemeStore>('BzThemeStore');

export const BzThemeStoreProvider: React.FC<React.PropsWithChildren> = observer((props) => {
  const [store] = React.useState(() => new BzThemeStore());

  return (
    <BzThemeStoreContext.Provider value={store}>{props.children}</BzThemeStoreContext.Provider>
  );
});

BzThemeStoreProvider.displayName = 'BzThemeStoreProvider';

class BzThemeStore {
  @observable theme: ITheme = {
    ...defaultTheme
  };
}

export default BzThemeStore;
